(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kv-product"]) return;
  try {
    
function initKevantoProducts(root = document) {
  root.querySelectorAll('[data-kv-product]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const picker = section.querySelector('[data-kv-variant]');
    const image = section.querySelector('.kv-main-image');
    const button = section.querySelector('[data-kv-add]');
    picker?.addEventListener('change', () => {
      const option = picker.selectedOptions[0];
      section.querySelector('[data-kv-price]').textContent = option.dataset.price;
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.unavailableText : button.dataset.availableText;
      if (option.dataset.image && image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
      const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
    });
    section.querySelectorAll('[data-kv-image]').forEach(thumbnail => thumbnail.addEventListener('click', () => {
      if (!image) return;
      image.removeAttribute('srcset'); image.src = thumbnail.dataset.kvImage;
      section.querySelectorAll('[data-kv-image]').forEach(item => item.setAttribute('aria-pressed', String(item === thumbnail)));
    }));
  });
}
initKevantoProducts();
document.addEventListener('shopify:section:load', event => initKevantoProducts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
